import { render, staticRenderFns } from "./StudentTransferListDialog.vue?vue&type=template&id=fd146fe6"
import script from "./StudentTransferListDialog.vue?vue&type=script&lang=js"
export * from "./StudentTransferListDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentTransferListDialog.vue?vue&type=style&index=0&id=fd146fe6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd146fe6')) {
      api.createRecord('fd146fe6', component.options)
    } else {
      api.reload('fd146fe6', component.options)
    }
    module.hot.accept("./StudentTransferListDialog.vue?vue&type=template&id=fd146fe6", function () {
      api.rerender('fd146fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentTransferDialog/StudentTransferListDialog.vue"
export default component.exports